export enum RelatedTagPositionEnum {
  BEFORE_QUERY = 'before-query',
  AFTER_QUERY = 'after-query',
}
